const nameArgument = require('./name-argument');

module.exports = {
  nameArgument,
};
